import { makeStyles, tokens, Tooltip } from '@fluentui/react-components';
import { ConnectorIcon } from '@/components/ConnectionsView/ConnectorIcon';

// =============================================================================
// STYLES
// =============================================================================

const CONTAINER_SIZE = '28px';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: CONTAINER_SIZE,
    height: CONTAINER_SIZE,
    borderRadius: tokens.borderRadiusMedium,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    flexShrink: 0,
  },
  overflowBadge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: CONTAINER_SIZE,
    height: CONTAINER_SIZE,
    borderRadius: tokens.borderRadiusMedium,
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    backgroundColor: tokens.colorNeutralBackground1,
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightMedium,
    color: tokens.colorNeutralForeground3,
    flexShrink: 0,
  },
});

// =============================================================================
// PROPS
// =============================================================================

export interface ConnectorIconRowProps {
  connectors: ReadonlyArray<{ id: string; displayName: string; iconUrl: string }>;
  maxVisible?: number;
}

// =============================================================================
// COMPONENT
// =============================================================================

export const ConnectorIconRow = ({ connectors, maxVisible = 4 }: ConnectorIconRowProps) => {
  const styles = useStyles();

  if (connectors.length === 0) return null;

  const visible = connectors.slice(0, maxVisible);
  const overflow = connectors.length - maxVisible;

  return (
    <div className={styles.row}>
      {visible.map((connector) => (
        <Tooltip content={connector.displayName} relationship="label" key={connector.id}>
          <div className={styles.iconContainer}>
            <ConnectorIcon iconUri={connector.iconUrl} size={16} />
          </div>
        </Tooltip>
      ))}
      {overflow > 0 && (
        <span className={styles.overflowBadge} aria-label={`${overflow} more connector${overflow !== 1 ? 's' : ''}`}>
          +{overflow}
        </span>
      )}
    </div>
  );
};
